const env: ImportMetaEnv = {
  VITE_BACKEND_API_BASE_URL: import.meta.env.VITE_BACKEND_API_BASE_URL,
  VITE_COGNITO_USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  VITE_COGNITO_USER_POOL_CLIENT_ID: import.meta.env
    .VITE_COGNITO_USER_POOL_CLIENT_ID,
  VITE_WEB_SOCKET_URL: import.meta.env.VITE_WEB_SOCKET_URL,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
};

export const getEnv = () => env;
